import React from "react";
import { IconChevronRight, IconEar, IconHeadphones } from "@tabler/icons-react";
import { useEffect } from "react";
import $ from "jquery";
import Odometer from "odometer.js"; // ✅ Correct import
import "odometer.js/odometer.css"; // ✅ Correct CSS import
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "./Industriescontent.css";

const Industries = () => {
  const industries = [
    { title: "Social Networking", description: "Building feature-rich social platforms to connect people seamlessly." },
    { title: "Digital Marketing", description: "Advanced tools for boosting brand engagement and online presence." },
    { title: "E-commerce Development", description: "Robust and scalable online stores to drive business growth." },
    { title: "Video Services", description: "High-performance streaming and video content management solutions." },
    { title: "Banking Services", description: "Secure and efficient banking applications for modern finance." },
    { title: "Education Services", description: "Smart e-learning platforms for enhanced educational experiences." },
    { title: "Tour and Travels", description: "Custom travel and booking solutions for seamless experiences." },
    { title: "Health Services", description: "Reliable healthcare software to improve patient care." },
    { title: "Event & Ticketing", description: "Efficient event management and ticket booking systems." },
    { title: "Restaurant Services", description: "Streamlined food ordering and management solutions." },
  ];
  useEffect(() => {
    // Initialize Odometer after component mounts
    const odometers = document.querySelectorAll(".odometer");
    odometers.forEach((el) => {
      new Odometer({
        el: el,
        value: parseInt(el.dataset.counterValue) || 0, // Ensure it's a number
        format: "(,ddd)", // Format numbers with commas
      });
    });
  }, []);

  return (
    <div>
      <section className="mt-[71px] bg-[url(../images/banner-bg.png)] bg-cover bg-no-repeat md:mt-[87px] xl:mt-0 ">
        <div className="bg-primary bg-opacity-40 py-[52px] mb-0">
          <div className="container text-n8">
            <h3 className="h3 mb-2.5">Industries</h3>
            <ul className="flex flex-wrap items-center gap-2">
              <li>
                <a href="/" className="home-link">
                  Home
                </a>
              </li>
              <li className="flex items-center">
                <IconChevronRight size={24} />
              </li>
              <li>
                <a href="/industries" className="home-link">
                  Industries
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/* <!-- banner content --> */}
      <section className="relative z-10 overflow-hidden bg-light py-5 ">
        <div className="container relative">
          <img
            src="assets/images/home-15-banner-element.png"
            alt="Image"
            className="absolute left-0 top-5 -translate-x-full max-xxxl:hidden"
          />
          <div className="grid-cols-12 items-center gap-5 max-lg:flex max-lg:flex-col-reverse sm:gap-8 lg:grid">
            <div className="relative z-10 col-span-12 lg:col-span-6" data-aos="fade-right">
              <h4 className="h4 mb-2.5" style={{ color: "rgb(0, 109, 178)" }}>
                Speed up your path to Industry 4.0.
              </h4>
              <h3 className="h3 mb-2.5 text-title">
                Make Your Next Hire Excellent & Effortless
              </h3>
              <p className="h5 mb-10 max-w-2xl font-normal text-[#5A5F96]">
                Superpowering people with Artificial Intelligence. Together, we
                deliver impactful AI solutions that your users will love.
              </p>
              <div className="flex flex-wrap gap-5 xl:gap-6">
                <a href="/contact" className="btn-primary">
                  Start Free Trial
                  <span
                    className="flex items-center justify-center rounded-full bg-white p-1 text-title"
                    style={{ color: "rgb(0, 109, 178)" }}
                  >
                    <IconChevronRight size={24} />
                  </span>
                </a>
                <a
                  href="/contact"
                  className="btn-white bg-white text-primary shadow-xl"
                >
                  <span style={{ color: "rgb(0, 109, 178)" }}>
                    Let's Talk Now
                  </span>
                  <span
                    className="flex items-center justify-center rounded-full p-1 text-white"
                    style={{ backgroundColor: "rgb(0, 109, 178)" }}
                  >
                    <IconHeadphones className="text-blue-600 w-6 h-6" />
                  </span>
                </a>
              </div>
            </div>
            <div className="col-span-12 lg:col-span-6" data-aos="fade-left">
              <div className="relative z-10">
                <img
                  src="assets/images/home-15-banner-image.png"
                  alt="Robot Image"
                  className="4xl:max-w-[unset]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
   

    {/* <!-- ========== Perks and Benefits ============ --> */}

    <section className="section bg-n8 pt-5"  style={{ backgroundColor: "#f5f5fd" }}>
      <div className="container">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 xl:col-span-5 xxl:col-span-6"data-aos="fade-right">
            <div className="sticky top-20 mt-5">
              <h5 className="h5 mb-4 mt-5" style={{ color: "rgb(0,109,178)" }}>
                Industries We Serve
              </h5>
              <h3 className="h3 mb-4 text-title">
                Empowering Businesses with Cutting-Edge Software Solutions
              </h3>
              <p className="mb-10 text-para2">
                We specialize in building robust digital solutions for a wide range of industries.
                From e-commerce to healthcare, our team is dedicated to delivering innovative and 
                tailored software development services.
              </p>
              <a className="btn-primary shrink-0" href="/contact">
                Get Started
                <span
                  className="flex items-center rounded-full bg-n8 p-1"
                  style={{ color: "rgb(0,109,178)" }}
                >
                  <IconChevronRight size={24} />
                </span>
              </a>
            </div>
          </div>
          <div className="col-span-12 grid grid-cols-2 gap-6 xl:col-span-7 xxl:col-span-6 " data-aos="fade-left">
            {industries.map((industry, index) => (
              <div key={index} className="col-span-2 md:col-span-1">
                <div className="rounded-[30px] border border-n5 p-3 md:p-4 lg:p-5 border border-primary shadow">
                  <h5 className="mb-3 mt-4 text-lg font-semibold leading-tight md:text-xl md:font-bold">
                    {industry.title}
                  </h5>
                  <p className="leading-6 text-para">{industry.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

      <section className="bg-n8 spb120px">
  <div className="container">
    <div className="mx-auto max-w-[758px] text-center " data-aos="fade-right">
      <h5 className="h5 mb-4" style={{ color: "rgb(0, 109, 178)" }}>
        Challenges we solve
      </h5>
      <h3 className="h3 mb-4 text-title">We make adoption of Industry 4.0 easy</h3>
      <p className="mx-auto mb-10 max-w-[697px] lg:mb-14">
        Data-driven AI solutions help manufacturers make quicker choices, minimize manual labor, eliminate human error, enhance operational efficiency, and boost revenues.
      </p>
    </div>

    <div className="grid-cols-12 flex-col-reverse items-center gap-4 max-xl:flex xl:grid xl:gap-6" data-aos="fade-left">
      <div className="order-1 col-span-12 xl:order-1 xl:col-span-6" dir="rtl">
        <img
          className="img-1 xl:mt-0 xxl:max-w-[unset]"
          src="assets/images/home-15-industry.png"
          alt="image"
          style={{
            transition: "transform 0.3s ease-in-out",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        />
      </div>
      <div className="order-2 col-span-12 xl:order-2 xl:col-span-6">
        <div className="grid gap-4 md:grid-cols-2 xl:gap-6">
          {[
            {
              img: "assets/images/expert-field-card-1.png",
              title: "New Revenue Streams",
              text: "Unlock new revenue streams for your company with data- & AI-driven products.",
            },
            {
              img: "assets/images/expert-field-card-2.png",
              title: "Superiority",
              text: "Get ahead of the curve by adopting Industry 4.0 and digital transformation.",
            },
            {
              img: "assets/images/expert-field-card-3.png",
              title: "Improved product quality",
              text: "Bring back data insights to your R&D and improve your products and services.",
            },
            {
              img: "assets/images/expert-field-card-4.png",
              title: "Say goodbye to guesswork",
              text: "Say goodbye to guesswork and make informed decisions backed by data.",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="group flex flex-col items-center rounded-[10px] border border-gray bg-n8 p-[30px] text-center text-title duration-300 hover:bg-primary hover:text-black border border-primary shadow"
              style={{
                transition: "transform 0.3s ease-in-out",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <img
                src={item.img}
                alt="img"
                className="w-24 h-auto"
                style={{
                  transition: "transform 0.3s ease-in-out",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
              <h6 className="h5 mt-7 font-semibold">{item.title}</h6>
              <p className="mt-4 text-[#5A5F96] group-hover:text-black">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>

    </div>
  );
};

export default Industries;
